import "./Notificationmodal.css";
import { useNavigate } from "react-router";
// import { ReactScrollPagination } from 'react-scroll-pagination';
import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { nfdata } from "../../service/Mainservice";
import moment from "moment";
// import InfiniteScroll from "react-infinite-scroll-component";
// import AppConfig from "../../Api/AppConfig";

const NotificationModal = ({ d, getcount }) => {
  const [currPage, setCurrPage] = useState(0);
  const [temp, settemp] = useState();
  const [hasNext, sethasNext] = useState();
  const [totalpage, setTotalpage] = useState();
  const [nf, setnf] = useState([]);
  const [load, setload] = useState(true);

  const navigate = useNavigate();
  const userToken = localStorage.getItem("ntk");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await nfdata();
      setnf(response.data.data);
      getcount();
      setload(false);
    } catch (error) {
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  //   const onScroll = () => {
  //     let CurrPage = currPage + 1;
  //     const params = new FormData();
  //     params.append("page", CurrPage);

  //     try {
  //       let config = {
  //         url: `${AppConfig.BASE_URL_v1}couple_notification_api`,
  //         method: "POST",
  //         data: params,
  //         headers: {
  //           Authentication: userToken,
  //         },
  //       };
  //       axios(config)
  //         .then((res) => res.data)
  //         .then((response) => {
  //           const redata = response.data;
  //           settemp(redata);
  //           const alldata = nf.concat(redata);
  //           setnf(alldata);
  //           const next = response.pagination.has_next;
  //           sethasNext(next);
  //           const data = response.pagination.page;
  //           setCurrPage(data);
  //           const tpage = response.pagination.total_pages;
  //           setTotalpage(tpage);
  //         })
  //         .catch((error) => {
  //           const err = error.response.data.message;
  //           if (error.response.data.code === 401) {
  //             localStorage.clear();
  //             navigate("/Login");
  //           }
  //         });
  //     } catch (error) {}
  //   };
  //   const chat = (e) => {
  //     if (e.room_id) {
  //       const room = e.room_id;
  //       localStorage.setItem("room_id", room);
  //       navigate("/Chat", {
  //         state: {
  //           name: e.title,
  //           pic: e.user_img,
  //         },
  //       });
  //     } else {
  //       localStorage.setItem("job_id", e.job_id);
  //       navigate(e.screen === "job_details" ? "/Jobdetail_Bid" : "");
  //     }
  //   };

  return (
    <>
      <div className="notificationmodal_content">
        <div className="notification_drop"></div>
        <h2 className="nf_heading">Notifications</h2>
        <div className="nf_scroll">
          {/* <InfiniteScroll
            dataLength={nf.length}
            next={onScroll}
            style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
            hasMore={hasNext}
            // inverse={true}
            height={400}
            loader={<h4>Loading...</h4>}
            scrollableTarget="notification_detail"
          > */}
          {load ? (
            <div className="nodata">Loading......</div>
          ) : nf?.length === 0 ? (
            <div className="nodata">No Notifications yet</div>
          ) : (
            <>
              {nf?.map((nf, index) => (
                <div className="notification_detail">
                  <p className="nf_title">{nf.title}</p>
                  <p className="nf_msg">{nf.body}</p>
                  <p className="nf_time">
                    {moment(nf.createdAt).startOf("hour").fromNow()}
                  </p>
                </div>
              ))}
            </>
          )}

          {/* </InfiniteScroll> */}
        </div>
      </div>
    </>
  );
};
export default NotificationModal;
